import AhmadAhmadLocales from "@/data/localization/AboutAhmad.locales";
import imageAltsLocales from "@/data/localization/imageAlts.locales";
import {
  HR,
  ImageOptimized,
  Title,
  useLocales,
} from "@crescentapplications/react-ui";
import Education from "./Education";
import Lineage from "./Lineage";
import Profile from "./Profile";
import Volunteering from "./Volunteering";
import WorkExperience from "./WorkExperience";

const imageBreakpoints = [384, 768, 1024, 1280, 1920];

export default function AboutAhmad() {
  const l = useLocales();

  return (
    <>
      <title>{l(AhmadAhmadLocales.pageTitle)}</title>
      <Title textAlign="center">{l(AhmadAhmadLocales.title)}</Title>

      <ImageOptimized
        alt={l(imageAltsLocales.ahmadIrvine)}
        borderRadius="md"
        breakpoints={imageBreakpoints}
        file="/assets/images/portraits/ahmad-irvine"
        format="webp"
        height={720}
        loading="eager"
        width={1280}
      />

      <Profile />

      <HR />

      <ImageOptimized
        alt={l(imageAltsLocales.madinahMosque)}
        borderRadius="md"
        breakpoints={imageBreakpoints}
        file="/assets/images/madinah"
        format="webp"
        height={720}
        width={1280}
      />

      <Lineage />

      <HR />

      <ImageOptimized
        alt={l(imageAltsLocales.ahmadGrayBg)}
        borderRadius="md"
        breakpoints={imageBreakpoints}
        file="/assets/images/portraits/ahmad-gray-bg"
        format="webp"
        height={720}
        width={1280}
      />

      <Education />

      <HR />

      <ImageOptimized
        alt={l(imageAltsLocales.ahmadConstruction)}
        borderRadius="md"
        breakpoints={imageBreakpoints}
        file="/assets/images/portraits/ahmad-construction"
        format="webp"
        height={720}
        width={1280}
      />

      <WorkExperience />

      <HR />

      <ImageOptimized
        alt={l(imageAltsLocales.ahmadOffice)}
        borderRadius="md"
        breakpoints={imageBreakpoints}
        file="/assets/images/portraits/ahmad-office"
        format="webp"
        height={720}
        width={1280}
      />

      <Volunteering />
    </>
  );
}
